<div
  class="avatar"
  [class.frontline]="player.frontline">
  <svg [attr.width]="(radius + strokeWidth) * 2" [attr.height]="(radius + strokeWidth) * 2">
    <g [attr.transform]="'rotate(90 ' + (radius + strokeWidth) + ' ' + (radius + strokeWidth) + ')'">
      <path class="arc" [class.best]="player.best" [class.reset]="reset" [attr.d]="this.generateCirclePath()" style.stroke-dasharray="{{ variableDash }} 226" ></path>
      <path id="textPath" [attr.d]="this.generateCirclePath(true)"></path>
      <g [attr.transform]="'rotate(180 ' + (radius + strokeWidth) + ' ' + (radius + strokeWidth) + ')'">
        <text class="text" *ngIf="player.best">
          <textPath xlink:href="#textPath" startOffset="50%">{{ 'Top' | translate }}</textPath>
        </text>
      </g>
    </g>
  </svg>
  <img src="{{player.img}}" onerror="this.src = '/assets/img/teams/default_player.jpg'" class="photo" alt="{{'Player photo' | translate}}">
</div>
<p class="name"><span class="number">{{ player.number }}</span>.{{ this.utils.getPlayerShortName(player.name) }}</p>
<div class="faults">
  <div class="progressbar tooltip"
    attr.data-tooltip="{{ ('Number of fouls' | translate) + ': ' + player.fouls }}">
    <div *ngFor="let fullBall of player.foulsArr" class="ball" [class.full]="fullBall"></div>
  </div>
  <div attr.data-tooltip="{{ 'First team' | translate }}" class="tooltip frontline">
    <img *ngIf="player.frontline" src="/assets/img/icons/frontline.svg">
  </div>
</div>
<p class="value">
  {{ player.value }}
  <span class="unit">{{ unit | translate }}</span>
</p>
